module.exports = __webpack_public_path__ + "img/0-04.956c3667.jpg";